<template>
  <div
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-weight: bold;
      font-size: 2em;
      color: black;
      height: 50vh;
      background-color: white;
    "
    v-if="loading"
  >
    Loading...
  </div>
  <div v-if="!loading" class="container">
    <h2>📄 New Purchase Order</h2>

    <!-- Main info grid -->
    <div class="form-grid">
      <div class="form-group">
        <label>PO Number</label>
        <input v-model="form.po_number" type="text" />
      </div>
      <div class="form-group">
        <label><span style="color: red">*</span>Order Date</label>
        <input v-model="form.order_date" type="date" />
      </div>
      <div class="form-group">
        <label><span style="color: red">*</span>Supplier</label>
        <select v-model="form.supplier_id">
          <option disabled value="">Select Supplier</option>
          <option
            v-for="supplier in suppliers"
            :key="supplier.id"
            :value="supplier.id"
          >
            {{ supplier.supplier_name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label><span style="color: red">*</span>Delivery Address</label>
        <textarea v-model="form.delivery_address" rows="2"></textarea>
      </div>

      <div class="form-group">
        <label><span style="color: red">*</span>Payment Terms</label>
        <select v-model="form.payment_terms">
          <option disabled value="">Select term</option>
          <option
            v-for="term in pay_term_choices"
            :key="term.id"
            :value="term.id"
          >
            {{ term.term }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Delivery Notes</label>
        <textarea v-model="form.delivery_notes" rows="2"></textarea>
      </div>
    </div>

    <!-- Items Section -->
    <section class="items-section">
      <h3>📝 Items</h3>

      <div v-for="(item, index) in form.items" :key="index" class="item-row">
        <div class="item-field">
          <label>Item</label>
          <div class="input-with-suggestions">
            <iteminput
              :Rowid="index.toString()"
              :type="'items'"
              @itemoption-check="takeItem"
            />
            <!-- <input
              v-model="item.item_name"
              type="text"
              @keyup="suggestItems($event, index)"
              placeholder="Start typing item..."
            />
            <ul v-if="item.suggestions.length" class="suggestions">
              <li
                v-for="suggestion in item.suggestions"
                :key="suggestion.id"
                @click="selectItem(suggestion, index)"
              >
                {{ suggestion.name }}
              </li>
            </ul> -->
          </div>
          <input type="hidden" v-model="item.item_id" />
        </div>

        <div class="item-field small">
          <label>Qty</label>
          <input
            v-model.number="item.quantity"
            type="number"
            min="1"
            @input="updateAmount(index)"
          />
        </div>

        <div class="item-field small">
          <label>Unit Price</label>
          <input
            v-model.number="item.unit_price"
            type="number"
            min="0"
            @input="updateAmount(index)"
          />
        </div>

        <div class="item-field small">
          <label>Amount</label>
          <input :value="item.amount.toFixed(2)" type="text" readonly />
        </div>

        <div class="item-field">
          <label>Description</label>
          <input v-model="item.description" type="text" />
        </div>

        <button @click="removeItem(index)" class="btn remove-btn">
          Remove
        </button>
      </div>

      <button @click="addItem" class="btn add-btn">+ Add Item</button>
    </section>

    <button @click="submitPO" class="btn submit-btn">
      💾 Save Purchase Order
    </button>
  </div>
</template>

<script>
import iteminput from "./components/iteminput.vue";
// import { generalApiRequest } from "../../api/apiIndex";
import { generalApiRequest } from "../../api/apiIndex";
import { JsItemName } from "./components/jscomponents";
export default {
  data() {
    const today = new Date().toISOString().split("T")[0];
    return {
      loading: false,
      form: {
        po_number: "",
        order_date: today,
        supplier_id: "",
        delivery_address: "",
        delivery_notes: "",
        payment_terms: "",
        items: [
          {
            item_id: "",
            item_name: "",
            quantity: 1,
            unit_price: 0,
            amount: 0,
            description: "",
            // suggestions: [],
          },
        ],
      },
      pay_term_choices: [],
      suppliers: [],
    };
  },
  components: {
    iteminput,
  },
  methods: {
    suggestItems(event, index) {
      const query = event.target.value.toLowerCase();
      this.form.items[index].suggestions = this.allItems.filter((i) =>
        i.name.toLowerCase().includes(query)
      );
    },
    async getPaymentTerms() {
      const res = await generalApiRequest("getAllPaymentTerms", "GET", {}, 1);
      this.pay_term_choices = res.data;
      console.log(res);
    },
    async getSuppliers() {
      const res = await generalApiRequest(
        "get_suppliers_unpaginated",
        "GET",
        {},
        1
      );
      this.suppliers = res.data;
    },
    takeItem(item, rowId) {
      const nm = JsItemName(
        item.brand_name,
        item.item_strength,
        item.item_name
      );
      const target = this.form.items[rowId];
      //
      target.item_name = nm;
      target.item_id = item.id;
    },
    selectItem(item, index) {
      const target = this.form.items[index];
      target.item_name = item.name;
      target.item_id = item.id;
      target.suggestions = [];
    },
    addItem() {
      this.form.items.push({
        item_id: "",
        item_name: "",
        quantity: 1,
        unit_price: 0,
        amount: 0,
        description: "",
      });
    },
    removeItem(index) {
      this.form.items.splice(index, 1);
    },
    updateAmount(index) {
      const item = this.form.items[index];
      item.amount = item.quantity * item.unit_price;
    },
    async submitPO() {
      if (
        !this.form.order_date ||
        !this.form.supplier_id ||
        !this.form.delivery_address.trim() ||
        !this.form.payment_terms
      ) {
        alert(
          "Please fill in all required fields before saving the purchase order."
        );
        return;
      }
      this.loading = true;
      await generalApiRequest(
        "inventory/createLocalPurchaseOrder",
        "POST",
        this.form,
        1
      );

      this.loading = false;
      window.location.reload();
    },
  },
  mounted() {
    this.loading = true;
    this.getPaymentTerms();
    this.getSuppliers();
    this.loading = false;
  },
};
</script>

<style scoped>
.container {
  max-width: 90vw;
  margin: 2rem auto;
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  font-family: "Segoe UI", sans-serif;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

h2,
h3 {
  font-weight: 700;
  margin-bottom: 1rem;
  color: #333;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.2rem;
  margin-bottom: 2rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-weight: 600;
  margin-bottom: 0.4rem;
}

input,
select,
textarea {
  padding: 0.6rem;
  border: 1.5px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border 0.3s;
}

input:focus,
select:focus,
textarea:focus {
  border-color: #2563eb;
  outline: none;
}

.items-section {
  margin-bottom: 2rem;
}

.item-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  background: #f9fafb;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  align-items: flex-end;
}

.item-field {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.item-field.small {
  max-width: 100px;
}

.input-with-suggestions {
  position: relative;
}

.input-with-suggestions input {
  width: 100%;
}

.suggestions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  list-style: none;
  background: #fff;
  border: 1px solid #ccc;
  margin: 0;
  padding: 0;
  border-radius: 6px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 10;
}

.suggestions li {
  padding: 0.5rem;
  cursor: pointer;
}

.suggestions li:hover {
  background: #e0e7ff;
}

.btn {
  padding: 0.55rem 1rem;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}

.add-btn {
  background: #2563eb;
  color: #fff;
}

.add-btn:hover {
  background: #1e40af;
}

.remove-btn {
  background: #dc2626;
  color: #fff;
  min-width: 80px;
}

.remove-btn:hover {
  background: #991b1b;
}

.submit-btn {
  width: 100%;
  padding: 1rem;
  background: #16a34a;
  color: #fff;
  font-size: 1.1rem;
  border-radius: 10px;
  margin-top: 1.5rem;
}

.submit-btn:hover {
  background: #15803d;
}

@media (max-width: 600px) {
  .item-row {
    flex-direction: column;
  }

  .item-field.small {
    max-width: 100%;
  }
}
</style>
